import { render, staticRenderFns } from "./CollapsiblePanel.vue?vue&type=template&id=1083820d&scoped=true&"
import script from "./CollapsiblePanel.vue?vue&type=script&lang=ts&"
export * from "./CollapsiblePanel.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsiblePanel.vue?vue&type=style&index=0&id=1083820d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1083820d",
  null
  
)

export default component.exports